import { metricsApiClient } from './wireApiClient'

export type VisualInteractionMethod =
  | 'CLICK'
  | 'DBL_CLICK'
  | 'TRIPLE_CLICK'
  | 'LIGHTBOX_OPEN'
  | 'LIGHTBOX_CLOSE'
  | 'FULLSCREEN_OPEN'
  | 'FULLSCREEN_CLOSE'
  | 'DRAG'
  | 'SEEK'
  | 'VIEW_ENTER'
  | 'VIEW_EXIT'
  | 'HOVER_OVER'
  | 'PLAY'
  | 'PAUSE'
  | 'COMPLETE'
  | 'SCROLL'
  | 'OTHER'
  | 'UNKNOWN'

export type VisualType =
  | 'ACCORDION'
  | 'AUDIO'
  | 'IMAGE'
  | 'VIDEO'
  | 'TABLE'
  | 'GALLERY'
  | 'COMPARISON'
  | 'LEGACY_VISUAL'
  | 'OTHER'
  | 'UNKNOWN'

export type VisualInteractionPayload = {
  visualType: VisualType
  interactionMethod: VisualInteractionMethod
  clientTimestamp: number
}

export async function trackArticleVisualInteraction(
  articleId: string,
  visualId: string,
  payload: VisualInteractionPayload,
): Promise<void> {
  await metricsApiClient.put(`/collection/article/${articleId}/visuals/${visualId}`, payload)
}